export enum PaymentMeans {
  PAYPAL = 'PAYPAL',
  IBAN = 'IBAN',
  BBAN = 'BBAN',
  SWISH = 'SWISH',
  PLUSGIRO = 'PLUSGIRO',
  OTHER = 'OTHER',
  BANKGIRO = 'BANKGIRO',
}
export interface PaymentMeanInterface {
  _id?: string
  fields: { [key: string]: string }
  type: PaymentMeans
  optionalIBANs?: Array<{ [key: string]: string }>
}
